import { ContainerVm, Headers, ResourceVm } from 'qp-ui-interface';
import { getAppVersion, getDeviceType } from 'qp-utility';
import { LocalStorageKeys } from '../LocalStorageKeys';
import { getXClientId } from './deviceUtils';
import { LocalStorageService } from '../services/local-storage/local-storage.service';
import { StorefrontService } from '../../storefront/storefront.service';
import { CarouselStyle, CarouselType } from '../shared-components/cards-carousel/model/cards-carousel-models';
import { getCarouselImageWidth, getCarouselType } from './cardsCarouselUtils';

/**
 *
 * @param addClientId
 * @returns
 */
export const getQPHeaders = (addClientId = false, localStorage: LocalStorageService): Headers => {
  const tokens = {
    authToken: localStorage.getItem(LocalStorageKeys.AUTHDATA),
    xAuthToken: localStorage.getItem(LocalStorageKeys.XAUTH_TOKEN),
  };
  if (addClientId) {
    tokens['xClientId'] = getXClientId();
  }
  return tokens;
};

/**
 * Replace hero carousel image with the proper width and aspect ratio
 *
 * @param imageUrl
 * @returns
 */
export const addHeroImageParams = (hero: ContainerVm): ContainerVm => {
  // Get the width for the current container
  const newWidth = getCarouselImageWidth(CarouselType.HERO);
  for (let i = 0; i < hero?.resources?.length; i++) {
    let image = hero.resources[i].image;
    image = image.substring(0, image.indexOf('='));
    image += `=${newWidth}`;
    image += `&dt=${getDeviceType()}`;
    image += `&appVersion=${getAppVersion()}`;
    hero.resources[i].image = image.replace('16x9', '3x1');
  }
  return hero;
};

export const handleOnGoingCarousel = async (
  containersCarousels: ContainerVm[],
  storefrontService: StorefrontService
): Promise<{
  carousels: ContainerVm[];
}> => {
  try {
    // search for ongoing carousel
    const ongoingCarouselIndex = containersCarousels?.findIndex((container) => container.sourceType === CarouselStyle.ON_GOING);
    if (ongoingCarouselIndex >= 0) {
      let ongoingCarousel = containersCarousels[ongoingCarouselIndex];
      const ongoingResources = await storefrontService.fetchOngoing();

      ongoingCarousel.resources = ongoingResources;
      ongoingCarousel = handleNewCarouselWidth(ongoingCarousel, 'w');

      containersCarousels = containersCarousels.map((container, index) => (index === ongoingCarouselIndex ? ongoingCarousel : container));
    }
  } catch {}
  return {
    carousels: containersCarousels,
  };
};

/**
 * Iterates through each container provided and updates the image URLs in the
 * `resources` array of each container.
 */

export const updateContainersImageWidths = (containers: ContainerVm[]): ContainerVm[] => {
  return containers.map((container) => {
    return handleNewCarouselWidth(container);
  });
};

/**
 * Calculate the width  of the images based on the screen size and aspect ratio.
 * The image URL's `width` query parameter is then replaced with the newly
 * calculated width, ensuring the correct size is applied to the images.
 */
export const updateResourcesImageWidths = (resources: ResourceVm[], newWidth: number, queryString?: string): ResourceVm[] => {
  return resources.map((resource) => {
    if (resource.image) {
      // Replace the width parameter in the image URL
      const updatedImageUrl = queryString
        ? `${resource.image}?${queryString}=${newWidth}`
        : resource.image.replace(/(width=\d+)/, `width=${newWidth}`);
      return { ...resource, image: updatedImageUrl };
    }
    return resource;
  });
};

/**
 * Based on carousel type set style and images width
 */

export const handleNewCarouselWidth = (container: ContainerVm, queryString?: string): ContainerVm => {
  const style = getCarouselType(container);
  // Update the container style
  container.carouselType = style;
  // Get the width for the current container
  const newWidth = getCarouselImageWidth(style, container.aspectRatio);
  // Update the resources in the container with the new width in the image URL
  container.resources = updateResourcesImageWidths(container.resources, newWidth, queryString);

  return container;
};
